export class Adapter {
  constructor(
    public hash?: string,
    public name?: string,
    public type?: number
  ) { }

  clone() {
    return new Adapter(
      this.hash,
      this.name,
      this.type
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/adapter.ts